// SPDX-License-Identifier: Apache-2.0
import Map2dComponent from './component';

/**
 * The `<girafe-map>` Element of the previous versions, kept as a deprecated alias of
 * `<girafe-map-2d>` to give the applications using GeoGirafe time to migrate.
 *
 * It keeps the component name `map`, so that the custom styles and the feedback configuration
 * that were written for `<girafe-map>` keep working. It only displays the 2D Map: an application
 * that needs the 3D Map has to add a `<girafe-map-3d>` Element next to it.
 *
 * @deprecated Use `<girafe-map-2d>` (and `<girafe-map-3d>` for the 3D Map) instead.
 */
export default class DeprecatedMapComponent extends Map2dComponent {
  public constructor() {
    super('map');
  }

  protected override connectedCallback() {
    console.warn(
      '<girafe-map> is deprecated and will be removed in a future version. ' +
        'Please replace it with <girafe-map-2d>. ' +
        'If your application uses the 3D Map, add a <girafe-map-3d> Element next to it, ' +
        'otherwise the 3D Map will not be displayed anymore.'
    );
    super.connectedCallback();
  }
}
